'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _ProductItem = require('../components/ProductItem');

var _ProductItem2 = _interopRequireDefault(_ProductItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Static404 = function () {
  function Static404(section) {
    (0, _classCallCheck3.default)(this, Static404);

    this.el = section.el;
    this.productEls = this.el.querySelectorAll('[data-product-item]');
    this.products = [];

    for (var i = 0; i < this.productEls.length; i++) {
      this.products.push(new _ProductItem2.default(this.productEls[i]));
    }

    if (window.location.href.indexOf('products') > -1) {
      if (document.querySelector('.fof-page')) {
        document.querySelector('.fof-page').classList.add('this-is-a-product');
      }
    }
  }

  (0, _createClass3.default)(Static404, [{
    key: 'onSectionUnload',
    value: function onSectionUnload() {
      this.products.forEach(function (product) {
        return product.unload();
      });
    }
  }]);
  return Static404;
}();

exports.default = Static404;